export default {
  app: {
    title: 'Transfer Service',
    subtitle: '予約、注文確認、お支払い状況の確認',
    language: '言語'
  },
  common: {
    ok: 'OK',
    systemError: 'システムエラー'
  },
  notFound: {
    title: 'ページが見つかりません',
    description: 'アクセスしたページは存在しません。リンクが無効になっているか、URL が間違っている可能性があります。'
  },
  action: {
    booking: '予約する',
    queryOrder: '注文を確認',
    submit: '送信',
    continue: '続行',
    cancel: 'キャンセル',
    backHome: 'ホームへ戻る',
    expand: '展開',
    collapse: '閉じる',
    delete: '削除',
    yes: 'はい',
    no: 'いいえ'
  },
  booking: {
    title: '予約',
    successTitle: '予約を受け付けました',
    successDescription: '注文番号と照会コードを保存してください。注文番号、メールアドレス、照会コードで確認できます。',
    successOrderNo: '注文番号',
    successQueryCode: '照会コード',
    customerInfo: 'お客様情報',
    appointments: '予約行程',
    multiAppointmentHint: '1つの注文に複数の予約行程を含めることができます。',
    appointmentTitle: '予約 {index}',
    basicInfo: '基本情報',
    flightAndAddress: 'フライト・場所',
    extraServices: '追加サービス',
    addAppointment: '予約を追加',
    addTripDetail: '行程詳細を追加',
    snowboardHint: '4名以上でスキー／ゴルフバッグを持参する場合は Hiace をおすすめします。',
    babySeatLabel: 'チャイルドシート（{free}個無料、{from}個目から1個あたり {price}）',
    babySeatSimpleHint: '2個目から +¥1,500 / 個',
    supermarketPriceItem: '{hour}時間 {price}',
    tripEstimate: 'この行程の概算料金',
    totalEstimate: '注文の概算合計',
    priceBreakdown: {
      baseFare: '車両料金',
      earlyLateSurcharge: '早朝・深夜追加 {percent}',
      babySeat: 'チャイルドシート',
      supermarketStop: 'スーパー立ち寄り'
    },
    verifyEmailAndContinue: 'メールを確認して続行',
    sendEmailCode: 'メール認証コードを送信',
    resendEmailCode: '認証コードを再送信',
    resendCountdown: '{seconds} 秒後に再送信',
    emailCodeSent: '認証コードを送信しました。メールの認証コードを入力してください。',
    emailVerified: 'メール形式を確認しました',
    emailVerificationTitle: 'メール認証',
    emailVerificationDescription: 'メール認証コードを送信し、認証を完了してから予約を送信してください。',
    verifyAndSubmit: '認証して送信',
    carInfo: '車種情報',
    field: {
      name: 'お名前',
      email: 'メールアドレス',
      phone: '電話番号',
      verifyCode: '認証コード',
      serviceType: '商品名',
      date: '配車日',
      product: '商品名',
      transferRoute: '送迎ルート',
      carType: '車種',
      passengers: '人数',
      luggage: '合計荷物個数',
      snowboard: 'スキー／ゴルフバッグ',
      flightNo: 'フライト番号',
      flightTime: 'フライト時刻',
      arrivalTime: '到着時間',
      departureTime: '迎車時刻',
      pickupAddress: '迎車場所',
      meetingPlace: '待ち合わせ場所',
      dropoffAddress: '目的地',
      customDropoffAddress: '目的地を入力',
      tripDetails: '行程詳細',
      tripDetailTitle: '行程詳細 {index}',
      remark: '備考',
      supermarketStop: 'スーパー立寄り'
    },
    unit: {
      pieces: '{count} 個'
    },
    airportTerminal: {
      international: '国際線',
      domestic: '国内線'
    },
    serviceType: {
      airportPickup: '空港発の行程',
      airportDropoff: '空港へ向かう行程',
      pointToPoint: '送迎ルート一覧'
    },
    supermarketOption: {
      none: '不要',
      oneHour: '1時間',
      twoHours: '2時間',
      threeHours: '3時間'
    },
    surchargeHint: {
      pickup: '{before}前または{after}以降の行程には{percent}の追加料金がかかります。',
      departure: '{before}前または{after}以降に出発する行程には{percent}の追加料金がかかります。'
    },
    validation: {
      nameRequired: 'お名前を入力してください',
      emailRequired: 'メールアドレスを入力してください',
      emailInvalid: '有効なメールアドレスを入力してください',
      emailNotVerified: '先にメールを確認してください',
      emailCodeNotSent: '先にメール認証コードを送信してください',
      verifyCodeInvalid: '認証コードが正しくありません',
      verifyCodeInvalidRetry: '認証コードが正しくないか、有効期限が切れています。再送信してもう一度認証してください。',
      phoneRequired: '電話番号を入力してください',
      dateRequired: '予約 {index}: 日付を選択してください',
      noAvailablePricePeriod: '予約 {index}: この商品には本日以降の有効な料金期間がありません',
      dateOutOfPricePeriod: '予約 {index}: 選択した日付は商品の有効料金期間外です',
      productRequired: '予約 {index}: 商品を選択してください',
      carTypeRequired: '予約 {index}: 車種を選択してください',
      passengersRequired: '予約 {index}: 人数を選択してください',
      passengersOverCarLimit: '予約 {index}: この車種の最大人数は {max} 名です',
      flightNoRequired: '予約 {index}: フライト番号を入力してください',
      timeRequired: '予約 {index}: {field}を入力してください',
      pickupAddressRequired: '予約 {index}: 出発地点を入力してください',
      dropoffAddressRequired: '予約 {index}: 目的地を入力してください',
      tripDetailRequired: '予約 {index}: 行程詳細を入力してください',
      tripDetailMaxLength: '予約 {index}: 行程詳細は500文字以内で入力してください'
    }
  },
  order: {
    queryTitle: '注文確認', // 查询订单
    detailTitle: '注文詳細', // 订单详情
    tokenQueryDescription: '予約照会 token を入力してください。確認できた場合、予約詳細ページを表示します。',
    tokenPlaceholder: '予約照会 token を入力',
    checking: '確認中...',
    invalidTitle: '予約リンクが無効または期限切れです',
    invalidDescription: '該当する予約が見つからないか、照会 token の有効期限が切れています。token が完全か確認するか、スタッフにお問い合わせください。',
    orderInfo: '注文情報', // 订单信息
    orderStatus: '注文状態', // 订单状态
    paymentStatus: '支払い状態', // 支付状态
    loading: '注文詳細を読み込んでいます...', // 正在加载订单详情...
    tripItems: '行程詳細', // 行程明细
    sendVerifyCode: '認証コードを取得', // 获取验证码
    verifyAndViewDetail: '認証して注文詳細を表示',
    resendCode: '再取得', // 重新获取
    resendCountdown: '{seconds}秒後に再取得', // {seconds} 秒后重新获取
    verifyCodeSent: '認証コードを予約時のメールアドレスに送信しました。', // 验证码已发送，请查看预约邮箱。
    forgotVerifyCode: '認証コードをお忘れですか？',
    mockVerifyCodePlaceholder: '',
    field: {
      orderNo: '注文番号', // 订单号
      email: 'メールアドレス', // 邮箱
      verifyCode: '認証コード', // 验证码
      token: '照会 token'
    },
    detail: {
      orderNo: '注文番号',
      appointmentId: '予約ID',
      customerInfo: '顧客情報',
      basicInformation: '基本情報',
      flightAndAddress: 'フライト・住所',
      extraServices: '追加サービス',
      dateOfService: 'サービス日',
      carTypeMinMax: '車種（最少～最大）',
      passengerCount: '乗客人数',
      totalLuggage: '荷物合計',
      snowboard: 'スキー／ゴルフバッグ',
      flightNumber: 'フライト番号',
      flightTime: 'フライト時間',
      meetingPlace: '集合場所',
      destination: '目的地',
      seat: 'チャイルドシート',
      supermarketStop: 'スーパー立寄り',
      deliveryInfo: '配車情報',
      deliveryStatus: '配車状態',
      dispatched: '配車済み',
      notDispatched: '未配車',
      driverInfoVisibleSoon: '配車済みです。ドライバー情報は出発日の3日前から表示されます。',
      vehicle: '車両',
      licensePlate: '車番',
      driver: 'ドライバー',
      phone: '電話',
      estimatedArrival: '到着予定',
      waitingPlace: '待合場所'
    },
    validation: {
      orderNoRequired: '注文番号を入力してください', // 请输入订单号
      emailRequired: 'メールアドレスを入力してください', // 请输入邮箱
      verifyCodeRequired: '認証コードを入力してください', // 请输入验证码
      tokenRequired: '照会 token を入力してください'
    },
    status: {
      0: '確認待ち',
      1: '確認済み',
      pending: '確認待ち', // 待确认
      confirmed: '確認済み', // 已确认
      quoted: '見積済み', // 已报价
      cancelled: 'キャンセル済み', // 已取消
      completed: '完了', // 已完成
      unknown: '不明な状態' // 未知状态
    },
    info: {
      startDate: '開始日', // 开始日期
      companyId: '代理店ID', // 代理店ID
      bidStartTime: '入札開始時間', // 入札开始时间
      paymentAmount: '支払い金額', // 支付金额
      paymentEmail: '支払いメール', // 支付邮箱
      paymentEmailName: '支払いメール名', // 支付邮箱姓名
      paymentTaskId: '支払いタスクID', // 支付任务ID
      paymentUrl: '支払いリンク', // 支付链接
      paymentStripePid: 'Stripe支払いID', // Stripe 支付ID
      creator: '作成者', // 创建者
      createTime: '作成日時', // 创建时间
      updater: '更新者', // 更新者
      updateTime: '更新日時', // 更新时间
      branch: '予約枝番', // 预约分支
      copyBranch: '複製枝番', // 复制分支
      carType: '車種', // 车种
      people: '人', // 人
      passengers: '乗客人数', // 乘客人数
      flight: 'フライト番号', // 航班及号码
      flightDepartureTime: 'フライト出発時間', // 航班出发时间
      arrivalTime: 'フライト到着時間', // 航班到达时间
      departureTime: '迎車時刻', // 迎车时间
      boardAddress: '乗車場所', // 上车地点
      destination: '目的地', // 目的地
      customerName: '顧客名', // 客户姓名
      customerPhone: '顧客電話', // 客户电话
      customerEmail: '顧客メール', // 客户邮箱
      babySeat: 'チャイルドシート', // 儿童座椅
      remark: '備考', // 备注
      amount: '金額', // 金额
      cancelFee: 'キャンセル料' // 取消费用
    },
    appointmentCount: '{count} 件の予約', // {count} 个预约
    noAppointments: 'この注文にはまだ予約明細がありません。', // 此订单暂未包含预约明细。
    feeDetails: '料金明細', // 费用明细
    invoiceNo: '請求書番号', // 发票编号
    payNoticeNo: '支払通知番号', // 付款通知编号
    carrierInvoiceNo: '運行会社請求書番号', // 承运商发票编号
    processStatus: '処理状況', // 处理状态
    sellPrice: '販売価格', // 卖价
    grossPrice: '総額', // 总价
    netPrice: '正味価格', // 净价
    fee: '手数料', // 手续费
    otherFee10: 'その他料金 (10%)', // 其他费用 (10%)
    otherFee8: 'その他料金 (8%)', // 其他费用 (8%)
    administratorMemo: '管理者メモ' // 管理员备注
  },
  payment: {
    title: '請求とお支払い',
    billNumber: '請求書番号',
    billDate: '請求日',
    deadline: '請求締切日',
    receivedDate: '入金日',
    totalFee: '合計金額',
    currentBillAmount: '現在の請求金額',
    orderTotalAmount: '注文合計金額',
    amountToPayNow: '今回のお支払い金額',
    amountToPayNowHint: '支払いボタンを押すと、この金額で新しい Stripe 支払いページを作成します。',
    paidAmount: '入金済み金額',
    unpaidAmount: '未払い金額',
    refundAmount: '返金予定額',
    refundAmountPending: '返金予定額',
    refundAmountRefunded: '返金済み金額',
    refundAmountPartial: '一部返金済み金額',
    appointmentAmount: '予約料金',
    appointmentFeeDetails: '予約ごとの料金明細',
    originalAppointmentAmount: '元の予約料金',
    cancelFee: 'キャンセル料',
    cancelStatus: 'キャンセル状態',
    cancelStatusBeforePayment: '支払い前キャンセル（支払い・返金なし）',
    cancelStatusPaymentRequired: 'キャンセル後、キャンセル料の支払いが必要です',
    cancelStatusAfterPaymentNoRefund: '支払い後キャンセル（返金なし）',
    cancelStatusRefundPending: '支払い後キャンセル（返金予定）',
    cancelStatusPartialRefunded: '支払い後キャンセル（一部返金済み）',
    cancelStatusRefunded: '支払い後キャンセル（返金済み）',
    remark: '備考',
    downloadInvoice: '請求書をダウンロード',
    payNow: '今すぐ支払う',
    collectByHotel: '料金はホテルまたは旅行代理店へお支払いください。',
    collectByDriver: '料金はドライバーへお支払いください。',
    downloadSuccess: '請求書のダウンロードに成功しました',
    paymentUrlEmpty: '支払いリンクが取得できませんでした',
    status: {
      0: '未払い',
      1: '支払い済み',
      2: '支払い失敗',
      not_requested: '支払い未請求',
      unpaid: '未払い',
      pending: '支払い処理中',
      paid: '支払い済み',
      timeout: '支払い期限切れ',
      additionalRequired: '追加支払いが必要',
      partial: '一部支払い済み',
      failed: '支払い失敗',
      expired: '期限切れ',
      refunded: '返金済み',
      unknown: '不明な状態'
    }
  },
  message: {
    title: 'メッセージ / お問い合わせ',
    description: '行程の変更、追加情報、お支払いに関する質問がある場合はこちらに入力してください。',
    field: 'メッセージ内容',
    target: 'メッセージ対象',
    orderTarget: '注文全体',
    itemTarget: '行程 {index}',
    itemMessageButton: 'この行程にメッセージ',
    placeholder: 'メッセージを入力',
    submit: '送信',
    close: '閉じる',
    history: 'メッセージと返信',
    empty: 'メッセージはまだありません',
    customer: '自分のメッセージ',
    staff: 'スタッフからの返信',
    validationRequired: 'メッセージを入力してください',
    maxLengthExceeded: 'メッセージは {max} 文字以内で入力してください',
    submitSuccess: 'メッセージを送信しました'
  },
  policy: {
    eyebrow: 'Notice & Policy',
    title: '注意事項',
    description: 'Madoras\n貸切タクシー/バスについて',
    noticeTitle: '',
    cancelTitle: '変更・キャンセルポリシー',
    noticeItems: [
      '1.1 予約締切\n旅行日の7日前を予約締切とします。',
      '1.2 変更・取消手数料\n旅行実施日の7日前以降の予約変更またはキャンセルには、後記「第2条 変更・取消規定」に基づき所定の手数料を申し受けます。',
      '1.3 情報の正確性\n提供いただく情報に基づき、Madorasが手配を行うため、すべての情報は正確に入力ください。情報の誤りにより誤った手配が行われ、既に支払いが完了している場合には、一切の返金は行いません。',
      '1.4 無連絡不参加（ノーショー）\nロングプライムのドライバーが乗車予定のお客様を探したにもかかわらず、待ち合わせ場所に現れなかった場合、返金は一切行いません。',
      '1.5 集合場所\n乗客の人数に応じて、特定の集合場所にお越しいただく必要がある場合があります。詳細は予約確認メールでお知らせします。',
      '1.6 遅延・運行中止\n天候、交通状況、道路状況、その他不可抗力により、運行が遅延またはキャンセルされる場合があります。この場合でも、返金は一切行いません。',
      '1.7 フライト遅延・欠航\nお客様のフライトが遅延・欠航した場合で、Madorasへの連絡がなかった場合は、無連絡キャンセルとみなされ返金対象外となります。\n遅延の際は、速やかに弊社へ電話連絡をお願いいたします。：\n電話番号：+81-11-252-0066\nその時に車両について、現地でそのまま待機できるか、代替手配が可能か否か、確認いたします。連絡がないまま遅延到着した場合、次の予約の都合上、車両がすでに出発している可能性があり、またその場合も一切の返金はいたしかねます。',
      '1.8繁忙期・閑散期の料金変動\n料金は、繁忙期や閑散期に応じて変動する場合があります。表示料金は、予約締切（旅行日の7日前）までに適応される標準料金です。それ以降の急な手配には少なくとも20％の追加料金が発生する場合があります。',
      '1.9早朝・深夜料金\n以下の時間帯に該当する早朝および深夜の送迎には20％の追加料金が発生します。\n・早朝：迎車時間が午前6時30分より前\n・深夜：迎車もしくはフライト到着時間が午後9時30分以降',
      '1.10途中立ち寄り\nお客様が目的地に到着前に別の場所への立ち寄りを希望する場合、Madorasは新たな行程を見積もり、更新後の料金を別途提示しますので少しお時間をいただく可能性があります。',
      '1.11 料金改定の通知\nMadorasは、繁忙期や閑散期等の理由により料金を変更する場合がある。その旨を代理店はお客様に連絡する必要があります。'
    ],
    cancelItems: [
      '1 変更・取消の方法\n変更や取消は必ず営業時間内に、電話またはメールにて連絡をお願いいたします。その際、7桁の予約番号のご提示をお願いいたします。',
      '連絡先：info@nv-ae.com 　電話番号：011-252-9966\n※info@madoras.net宛のメールは受信専用のため、返信不可',
      '２対応時間\n営業時間（9:00～18:00）内の問い合わせには当日中に対応いたします。営業時間外の問い合わせは翌営業日の対応となりますことご了承ください。',
      '3 取消手数料\n・旅行日の7日前～2日前まで：料金の30％\n・前日の12:00正午まで：料金の50％\n・前日12:00以降または当日（無断キャンセル）：料金の100％',
      '４．予約受付の締め切り日以降に変更される場合、予約を一度キャンセルしていただいた後に再予約いただくことになります。',
      '５．予約締め切り日以降の変更によるキャンセル（上記４.）、または予約のキャンセルにつきましては上表通りのキャンセル料金が発生しますので予めご了承ください。',
      '６．カードのオンライン決済でお支払いいただいたお客様に返金が発生した場合は、運賃の６％の返金手数料を差し引いた金額を返金させていただきます。',
      '７．銀行口座への入金、および変更・キャンセルによる返金の場合、振込手数料はお客様負担とさせていただきます。'
    ]
  },
  error: {
    title: '続行できません',
    requestFailed: 'リクエストに失敗しました。しばらくしてから再度お試しください。',
    orderCredentialMismatch: '注文番号とメールアドレスが一致しません。確認して再度お試しください。',
    invalidVerifyCode: '認証コードが正しくありません。再度入力してください。',
    verifyCodeTooFrequent: '認証コードの再送信は少し時間をおいてからお試しください。',
    orderNotFound: '注文が見つかりません。注文番号とメールアドレスを確認してください。',
    bookingTokenInvalid: '注文リンクが無効、または有効期限が切れています。リンクが完全か確認するか、スタッフへお問い合わせください。',
    invoiceNotAvailable: 'お支払い完了後に請求書をダウンロードできます。',
    invoiceGenerateFailed: '請求書を作成できませんでした。しばらくしてから再度お試しいただくか、スタッフへお問い合わせください。'
  }
}
